import { IQueryParams } from './queryparams';

export type AdvertStatus = 'Draft' | 'PendingReview' | 'Published' | 'Rejected' | 'Archived';
export type AdvertCallToAction = 'None' | 'GetQuote' | 'Call' | 'WhatsApp' | 'Link';

/** Live adverts an insurer or broker may have at once; mirrors Advert.MaxLivePerAdvertiser on the API. */
export const MAX_LIVE_ADVERTS_PER_INSURER = 3;

export interface IInsurerAdvert {
  id: number;
  createdAt: string;
  updatedAt: string;
  /** Exactly one of these is set: who is advertising. */
  insurerId: number | null;
  intermediaryId: number | null;
  advertiserType: 'Insurer' | 'Broker';
  advertiserName: string;
  advertiserLogoUrl: string | null;
  title: string;
  summary: string;
  bannerImageUrl: string | null;
  bodyMarkdown: string;
  callToAction: AdvertCallToAction;
  callToActionValue: string | null;
  productId: number | null;
  productName: string | null;
  classOfBusinessName: string | null;
  status: AdvertStatus;
  startsAt: string | null;
  endsAt: string | null;
  sortOrder: number;
  submittedAt: string | null;
  reviewedAt: string | null;
  reviewNote: string | null;
}

export interface IInsurerAdvertRequest {
  insurerId?: number | null;
  intermediaryId?: number | null;
  title: string;
  summary: string;
  bannerImageUrl: string | null;
  bodyMarkdown: string;
  callToAction: AdvertCallToAction;
  callToActionValue: string | null;
  productId: number | null;
  startsAt: string | null;
  endsAt: string | null;
  sortOrder: number;
}

export interface IInsurerAdvertQuery extends IQueryParams {
  insurerId?: number | null;
  intermediaryId?: number | null;
  status?: AdvertStatus | null;
}

/** Views and taps from the client apps; see GET adverts/{id}/interactions. */
export interface IAdvertInteractionSummary {
  views: number;
  clicks: number;
  uniqueViewers: number;
  uniqueClickers: number;
  anonymousViews: number;
  /** Unique clickers over unique viewers, 0–1. */
  clickThroughRate: number;
  byDay: { date: string; views: number; clicks: number }[];
}

export interface IAdvertViewer {
  userId: number;
  name: string | null;
  email: string | null;
  phoneNumber: string | null;
  views: number;
  clicks: number;
  firstSeenAt: string;
  lastSeenAt: string;
}

export interface IAdvertViewerQuery extends IQueryParams {
  /** true: users who tapped; false: users who saw it but never tapped. */
  clicked?: boolean | null;
}
